import { render, staticRenderFns } from "./inspection-completed.vue?vue&type=template&id=962b7b92"
import script from "./inspection-completed.vue?vue&type=script&lang=js"
export * from "./inspection-completed.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports